import { Request, Response } from "express"

import { getRecipes } from "#services/recipe/list"

export const getList = async (req: Request, res: Response) => {
	console.log("receipe list")
	const list = await getRecipes()

	res.json(list)
}
